import * as React from 'react'
import { niceNumber } from '../../utils'
import { Help } from '../Help'
import { UprightStyle } from '../../types'

const style: UprightStyle = {
  paragraph: { margin: '10px 0 0 auto', fontStyle: 'italic' }
}

export const MoreThanXResults: React.FC<{ total: number; totalStatus?: string; reportName: string }> = props => {
  return (
    <p className="bp3-text-muted" style={style.paragraph}>
      {props.totalStatus && props.totalStatus === 'MORE_THAN' && 'More than '}
      {niceNumber(props.total)} result{props.total === 1 ? '' : 's'}
      {props.totalStatus && props.totalStatus === 'MORE_THAN' && (
        <>
          {' '}
          <Help>
            <p className="no-margin-bottom">
              Results are estimated at over
              <br />
              {niceNumber(props.total)} items. Use {props.reportName}
              <br />
              Report to get exact count.
            </p>
          </Help>
        </>
      )}
    </p>
  )
}
